<template>
    <div class="d-flex h-100">
        <div v-if="activeSlide" class="d-flex flex-column w-100 overflow-auto">
            <div class="flex-grow-1 position-relative">
                <transition name="slide" :enter-class="slideOffset < 0 ?'slide-right-position':'slide-left-position'"
                            :leave-to-class="slideOffset < 0 ?'slide-left-position':'slide-right-position'">
                    <Slide v-if="slide.id === activeSlide.id" v-for="slide in slides" :slide="slide" :active="slide.id === activeSlide.id" :key="slide.id"/>
                </transition>
            </div>
            <div class="mt-auto flex-shrink-1">
                <SlideIndicators/>
            </div>
        </div>
        <div v-else class="col min-vh-100" style="background: rgba(0,0,0,0.5)">
            <button class="btn d-lg-none text-light float-right m-3" type="button" @click.prevent="$emit('showNav')">
                <i class="fas fa-bars"></i>
            </button>
            <div class="d-flex vh-100 justify-content-center align-items-center">
                <div class="text-center text-white p-2">
                    <h3>{{ $t('js.slide_show.no_slide_active') }}</h3>
                    <p>{{ $t('js.slide_show.presentation_not_started') }}</p>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import Slide from "../../frontend/observer/Slide"
    import SlideIndicators from "../../shared/SlideIndicators"
    import {mapGetters, mapState} from "vuex"

    export default {
        name: "SlideTab",
        components: {SlideIndicators, Slide},
        computed: {
            ...mapState(['slides', 'slideOffset']),
            ...mapGetters(['activeSlide']),
        }
    }
</script>